import React, { useEffect, useRef, useState } from "react";
import logo from "../../images/logo.png";
import optionsvg from "../../images/options-svgrepo-com.svg";
import { useLocation } from "react-router-dom";

export const Navbar: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const liRef = useRef<HTMLLIElement | null>(null);

  const location = useLocation();

  // Set active tab on initial load
  useEffect(() => {
    const path = location.pathname;
    if (path === "/") setActiveTab("BRT 2025");
    else if (path === "/brt-2024") setActiveTab("BRT 2024");
    else if (path === "/training-registration") setActiveTab("Register");
    else if (path.startsWith("/intimation-letters")) setActiveTab("Intimations");
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        liRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        !liRef.current.contains(event.target as Node)
      ) {
        dropdownRef.current.classList.add("hidden");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="navbar bg-slate-50 sticky top-0 z-50 navbar-offset">
      <div className="flex-1">
        <a href="/">
          <div className="avatar justify-center items-center gap-2">
            <div className="w-20 rounded-xl">
              <img src={logo} alt="Logo" />
            </div>
            <p className="text-lg lg:text-3xl xl:text-4xl font-bold text-start text-sky-500">
              National Healthcare & Wellness mission
            </p>
          </div>
        </a>
      </div>

      <div className="hidden md:block md:flex-none">
        <div className="text-gray-500 order-3 w-full md:w-auto md:order-2">
          <ul className="flex font-semibold justify-between gap-2">
            <li
              className={`btn bg-slate-200 rounded-2 md:px-4 md:py-2 hover:text-sky-500 transition duration-300 ${
                activeTab === "BRT 2025" ? "text-sky-100 bg-slate-400" : ""
              }`}
            >
              <a href="/">BRT 2025-2026</a>
            </li>

            <li
              className={`btn bg-slate-200 rounded-2 md:px-4 md:py-2 hover:text-sky-500 transition duration-300 ${
                activeTab === "BRT 2024" ? "text-sky-100 bg-slate-400" : ""
              }`}
            >
              <a href="/brt-2024">BRT 2023-2024</a>
            </li>

            <li
              className={`btn bg-slate-200 rounded-2 md:px-4 md:py-2 hover:text-sky-500 transition duration-300 ${
                activeTab === "Register" ? "text-sky-100 bg-slate-400" : ""
              }`}
            >
              <a href="/training-registration">Register for Training</a>
            </li>

            {/* Intimations with dropdown */}
            <li
              ref={liRef}
              className={`relative btn bg-slate-200 rounded-2 md:px-4 md:py-2 hover:text-sky-500 transition duration-300 ${
                activeTab === "Intimations" ? "text-sky-100 bg-slate-400" : ""
              }`}
              onClick={() => {
                dropdownRef.current?.classList.toggle("hidden");
                setActiveTab("Intimations");
              }}
            >
              <span className="cursor-pointer">Intimations</span>

              <div
                ref={dropdownRef}
                className="hidden absolute top-full left-0 mt-2 w-48 bg-white border rounded shadow z-50"
              >
                <a
                  href="/intimation-letters-2025"
                  className="block px-4 py-2 hover:bg-gray-100 text-sm text-gray-700"
                >
                  BRT 2025–2026
                </a>
                <a
                  href="/intimation-letters-2023"
                  className="block px-4 py-2 hover:bg-gray-100 text-sm text-gray-700"
                >
                  BRT 2023–2024
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* Mobile dropdown */}
      <details className="dropdown dropdown-end md:hidden">
        <summary className="list-none">
          <img
            src={optionsvg}
            tabIndex={0}
            role="button"
            className="bg-slate-200 p-2 rounded w-10"
            alt="Options"
          />
        </summary>
        <ul
          tabIndex={0}
          className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-52"
        >
          <li>
            <a href="/">BRT 2025-2026</a>
          </li>
          <li>
            <a href="/brt-2024">BRT 2023-2024</a>
          </li>
          <li>
            <a href="/training-registration">Register for Training</a>
          </li>
          <li tabIndex={-1}>
            <details>
              <summary>Intimations</summary>
              <ul className="p-2">
                <li>
                  <a href="/intimation-letters-2025">BRT 2025–2026</a>
                </li>
                <li>
                  <a href="/intimation-letters-2023">BRT 2023–2024</a>
                </li>
              </ul>
            </details>
          </li>
        </ul>
      </details>
    </div>
  );
};
